/** Spring's rendered, masked token accompanies browser mutations only on this origin. */
export function csrfHeaders(url, initialHeaders) {
    const headers = new Headers(initialHeaders);
    if (new URL(url, document.baseURI).origin !== window.location.origin) return headers;

    const header = document.querySelector('meta[name="_csrf_header"]')?.content;
    const token = document.querySelector('meta[name="_csrf"]')?.content;
    if (header && token) headers.set(header, token);
    return headers;
}
